let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j2DU4")).then(() => parcelRequire('e2l8c'));